import clsx from 'clsx';
import React from 'react';
import { FormControlLabel, SwitchProps } from '@mui/material';

import AppSwitch from '../app-switch/AppSwitch';
import { useStyles } from './AppSwitchWithLabel.styles';
import theme from '../../../styles/theme';

interface AppSwitchWithLabelProps extends SwitchProps {
  label: React.ReactNode;
  labelClassName?: string;
  labelPlacement?: 'top' | 'start' | 'bottom' | 'end';
  fullWidth?: boolean;
  value: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function AppSwitchWithLabel(props: AppSwitchWithLabelProps) {
  const {
    label,
    labelClassName,
    labelPlacement = 'start',
    className,
    fullWidth,
    ...switchProps
  } = props;
  const { classes } = useStyles(theme);

  return (
    <FormControlLabel
      control={<AppSwitch className={className} {...switchProps} />}
      className={clsx(classes.switchControlLabel, labelClassName)}
      labelPlacement={labelPlacement}
      label={label}
      style={{
        width: fullWidth ? '100%' : 'auto',
        display: label ? 'inline-flex' : 'block',
      }}
    />
  );
}
